module.exports = __webpack_public_path__ + "c061486698cd7c07c222311251aa89f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/features/screens/hike/large.png
// module id = 1814
// module chunks = 1